export const SUGGESTED_FIELD_FETCH_REQUEST = 'SUGGESTED_FIELD_FETCH_REQUEST';
export const SUGGESTED_FIELD_FETCH = 'SUGGESTED_FIELD_FETCH';
